module.exports = __webpack_public_path__ + "img/dcmm_26.26e47e01.png";